import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.where,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择紧急状态"
    },
    model: {
      value: _vm.where.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "emergency", $$v);
      },
      expression: "where.emergency"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告分类",
      "prop": "cateId"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择公告分类"
    },
    model: {
      value: _vm.where.cateId,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "cateId", $$v);
      },
      expression: "where.cateId"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateId
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  })], 2)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "拟稿日期",
      "prop": "startAndEndTime"
    }
  }, [_c('a-range-picker', {
    model: {
      value: _vm.where.startAndEndTime,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "startAndEndTime", $$v);
      },
      expression: "where.startAndEndTime"
    }
  })], 1)], 1)], 1), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "title",
      "label": "搜索"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公告标题、拟稿人姓名"
    },
    model: {
      value: _vm.where.title,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "title", $$v);
      },
      expression: "where.title"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetch({
          current: 1,
          pageSize: 10
        });
      }
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row) {
        return row.id;
      },
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.data,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.createUserName, "(").concat(row.organName, "/").concat(row.postName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.createUserName) + " (" + _vm._s(row.organName) + " / " + _vm._s(row.postName) + ") ")])];
      }
    }, {
      key: "emergency",
      fn: function fn(text, row) {
        return [1 === row.emergency ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("常规")]) : _vm._e(), 2 === row.emergency ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("紧急")]) : _vm._e(), 3 === row.emergency ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("重要")]) : _vm._e()];
      }
    }, {
      key: "noticeStatus",
      fn: function fn(text, row) {
        return [0 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待审核")]) : _vm._e(), 2 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("通　过")]) : _vm._e(), 3 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("不通过")]) : _vm._e(), 4 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("撤　回")]) : _vm._e(), 5 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-purple"
        }, [_vm._v("已发布")]) : _vm._e(), 6 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-shallow-orange"
        }, [_vm._v("审核中")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewNotice(row);
            }
          }
        }, [_vm._v("查看")])], 1), 0 === row.noticeStatus || 4 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.submitNotice(row);
            }
          }
        }, [_vm._v("提交")])], 1) : _vm._e(), 0 === row.noticeStatus || 4 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.editNotice(row);
            }
          }
        }, [_vm._v("编辑")])], 1) : _vm._e(), 0 === row.noticeStatus || 4 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.delNotice(row);
            }
          }
        }, [_vm._v("删除")])], 1) : _vm._e(), 1 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.withdrawNotice(row);
            }
          }
        }, [_vm._v("撤回")])], 1) : _vm._e(), 2 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.releaseNotice(row);
            }
          }
        }, [_vm._v("发布")])], 1) : _vm._e(), row.director && 1 === row.noticeStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.appendAudit(row, 3);
            }
          }
        }, [_vm._v("加后签")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_c('a-button-group', [_c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNotice
    }
  }, [_vm._v("拟稿")])], 1)], 1)], 2)], 1), _c('a-drawer', {
    attrs: {
      "title": _vm.appendTitle,
      "width": "50%",
      "visible": _vm.visibleMode,
      "body-style": {
        paddingBottom: '80px'
      },
      "zIndex": 999,
      "placement": "left"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_vm.signRecord.length === 0 ? _c('div', [_c('a-empty')], 1) : _c('div', _vm._l(_vm.signRecord, function (sign, index) {
    return _c('div', {
      key: index
    }, [_c('a-row', {
      style: {
        marginBottom: '10px'
      },
      attrs: {
        "gutter": 12
      }
    }, [_c('a-col', {
      attrs: {
        "span": 10
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("加签名称： "), _c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": sign.appendName
      }
    }, [_vm._v(_vm._s(sign.appendName))])])]), _c('a-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("排序： "), _c('span', {
      style: {
        color: '#c2c2c2'
      }
    }, [_vm._v(_vm._s(sign.sort))])])]), _c('a-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "text-ellipsis"
    }, [_vm._v("处理人或岗位： "), sign.postName && sign.userName && sign.organName ? _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": "".concat(sign.userName, "(").concat(sign.organName, "/").concat(sign.postName, ")")
      }
    }, [_vm._v(_vm._s(sign.userName) + " (" + _vm._s(sign.organName) + " / " + _vm._s(sign.postName) + ")")])]) : sign.postName && sign.organName ? _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": "".concat(sign.organName, "/").concat(sign.postName)
      }
    }, [_vm._v(_vm._s(sign.organName) + " / " + _vm._s(sign.postName))])]) : _c('span', [_c('span', {
      style: {
        color: '#c2c2c2'
      },
      attrs: {
        "title": sign.userName || sign.postName
      }
    }, [_vm._v(_vm._s(sign.userName) + " / " + _vm._s(sign.postName))])])])])], 1)], 1);
  }), 0), _c('a-divider'), _c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.appendFormObj,
      "label-col": {
        span: 0
      },
      "wrapper-col": {
        span: 24
      }
    }
  }, [_vm._l(_vm.appendFormObj.records, function (record, index) {
    return _c('div', {
      key: index
    }, [_c('a-row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('a-col', {
      attrs: {
        "span": 5
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.appendname',
        "rules": {
          required: true,
          message: '请输入加签名称',
          trigger: 'blur'
        }
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "placeholder": "请输入加签名称"
      },
      model: {
        value: record.appendname,
        callback: function callback($$v) {
          _vm.$set(record, "appendname", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "record.appendname"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 2
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.sort',
        "rules": {
          required: true,
          message: '排序',
          trigger: 'blur'
        }
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%',
        pointerEvents: 'none'
      },
      attrs: {
        "min": 1,
        "max": 9999,
        "precision": 0,
        "placeholder": "排序"
      },
      model: {
        value: record.sort,
        callback: function callback($$v) {
          _vm.$set(record, "sort", $$v);
        },
        expression: "record.sort"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 16
      }
    }, [_c('a-form-model-item', {
      attrs: {
        "prop": 'records.' + index + '.customize',
        "rules": {
          type: 'object',
          required: true,
          fields: {
            postData: {
              type: 'array',
              required: record.customize.userData.length === 0 && record.customize.postData.length === 0,
              message: '请选择岗位或者成员',
              trigger: 'change'
            },
            userData: {
              type: 'array',
              required: record.customize.userData.length === 0 && record.customize.postData.length === 0,
              message: '请选择岗位或者成员',
              trigger: 'change'
            }
          }
        }
      }
    }, [_c('select-person', {
      staticClass: "publish-person",
      attrs: {
        "tabList": _vm.userTabList,
        "isRadio": 1,
        "width": "100%",
        "height": "40px"
      },
      model: {
        value: record.customize,
        callback: function callback($$v) {
          _vm.$set(record, "customize", $$v);
        },
        expression: "record.customize"
      }
    })], 1)], 1), _c('a-col', {
      attrs: {
        "span": 1
      }
    }, [_c('a-popconfirm', {
      attrs: {
        "title": "确认删除吗？数据将不会保存!",
        "ok-text": "确认",
        "cancel-text": "取消"
      },
      on: {
        "confirm": function confirm($event) {
          return _vm.removeDomain(record);
        }
      }
    }, [_c('a-icon', {
      style: {
        fontSize: '20px',
        margin: '5px'
      },
      attrs: {
        "type": "minus-circle-o",
        "title": "删除"
      }
    })], 1)], 1)], 1)], 1);
  }), _c('a-form-model-item', {
    attrs: {
      "wrapper-col": {
        span: 24
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v(" 添加 ")], 1)], 1)], 2), _c('div', {
    staticClass: "footer"
  }, [_c('a-button', {
    style: {
      marginRight: '8px'
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.modalLoading
    },
    on: {
      "click": function click($event) {
        return _vm.handleOk();
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "选择模板",
      "centered": true,
      "maskClosable": false
    },
    model: {
      value: _vm.templateSelect,
      callback: function callback($$v) {
        _vm.templateSelect = $$v;
      },
      expression: "templateSelect"
    }
  }, [_c('div', {
    staticClass: "templateSelect-item"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 6
    },
    on: {
      "click": function click($event) {
        return _vm.chooseTemplate(0);
      }
    }
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "3.125rem"
    },
    attrs: {
      "type": "file-protect"
    }
  })], 1), _c('a-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 18
    },
    on: {
      "click": function click($event) {
        return _vm.chooseTemplate(0);
      }
    }
  }, [_c('a-popover', {
    attrs: {
      "placement": "topLeft"
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('p', [_vm._v("党委办、纪委办、行政办、人力资源部、财务室，需审核后方可发布。")])]), _c('span', {
    staticClass: "tag-name"
  }, [_vm._v(" 审批型 ")])], 2)], 1), _c('a-col', {
    attrs: {
      "span": 6
    },
    on: {
      "click": function click($event) {
        return _vm.chooseTemplate(1);
      }
    }
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "3.125rem"
    },
    attrs: {
      "type": "file-protect"
    }
  })], 1), _c('a-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 18
    },
    on: {
      "click": function click($event) {
        return _vm.chooseTemplate(1);
      }
    }
  }, [_c('a-popover', {
    attrs: {
      "placement": "topLeft"
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('p', [_vm._v("无审批流")])]), _c('span', {
    staticClass: "tag-name"
  }, [_vm._v(" 通用型 ")])], 2)], 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": _vm.closeSelectTemp
    },
    slot: "footer"
  }, [_c('a-button', [_vm._v("关闭")])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };